import React from 'react'
import PropTypes from 'prop-types'
import ControlsGroup from '#components/m/ControlsGroup'

export default class PageHeader extends React.Component {
  render() {
    return (
      <div className="page__header">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7">{this.props.headline}</div>
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5">
            <ControlsGroup>{this.props.button}</ControlsGroup>
          </div>
        </div>
      </div>
    )
  }
}

PageHeader.propTypes = {
  headline: PropTypes.node,
  button: PropTypes.node,
}
